import { EditableText } from "@/components/EditableText";
import { showApiError, showSuccess } from "@/lib/toast";
import { HospitalityMenuCategory } from "@/lib/types";
import { updateHospitalityMenuCategoryName } from "@/sideEffects/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

interface Props {
  category: HospitalityMenuCategory;
}

export const HospitalityMenuCategoryName: React.FC<Props> = ({ category }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const updateNameMutation = useMutation({
    mutationFn: (name: string) => updateHospitalityMenuCategoryName(category.hMenu_Id, category.id, name),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getHospitalityMenuCategory"],
      });
      showSuccess(t("common.updatedSuccess"));
    },
    onError: showApiError,
  });

  return (
    <div className=" w-full">
      <div className="text-sm">
        <EditableText
          initialText={category.name}
          onSave={updateNameMutation.mutate}
          isLoading={updateNameMutation.isPending}
          isFinishedLoading={updateNameMutation.isSuccess}
        />
      </div>
    </div>
  );
};
